export const portalVersion = "6.0.0"; 
